import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { ButtonLabel, PrimaryButton } from "../components/Buttons";
import BustBetweenBoots from "../assets/gallery/bustBetweenBoots.jpeg";
import CropPapi from "../assets/gallery/cropPapi.jpeg";

export const ServeSection = () => {
  return (
    <SectionOuter>
      {/* ── Section-level Paths heading ── */}
      <Centered>
        <PathsHeader>
          <PathsScriptina>Paths</PathsScriptina>
          <PathsLabel>Paths</PathsLabel>
        </PathsHeader>
      </Centered>

      {/* ── Row 1: The Descent — image right ── */}
      <RowBlock>
        <Centered>
          <RowLabel>I — Committed</RowLabel>
          <RowTitle>Descend into my Inner Circle...</RowTitle>
        </Centered>

        <Centered>
          <ServePair>
            {/* Text first in DOM, image right → image appears above on mobile */}
            <TextBody imageSide="right">
              <BodyText>
                The Descent is an ongoing dynamic — a real D/s relationship that
                blends in-person experiences with remote contact, structured
                across levels of depth and intimacy. This is not a content
                subscription. It is not media consumed for entertainment. It is
                the crown jewel of my 10 years of experience as a Dominatrix.
                And it is about intimacy, depth, power, partnership, and
                closeness.
                <br />
                <br />I will challenge you to become not only a better
                submissive, but a better human. I can be the one holding you
                accountable — for your goals, your projects, your growth. I will
                be witness and cause of your suffering and your pleasure. Your
                loyalty is rewarded with cruel affection, priority on my time,
                and merciful tributes for in-person sessions.
                <br />
              </BodyText>
              <ButtonRow>
                <Link to="/the-descent">
                  <PrimaryButton>
                    <ButtonLabel>I&apos;m ready, Mistress.</ButtonLabel>
                  </PrimaryButton>
                </Link>
              </ButtonRow>
            </TextBody>

            <ImageCell mobileFirst>
              <ServeImage image={BustBetweenBoots} />
            </ImageCell>
          </ServePair>
        </Centered>
      </RowBlock>

      {/* ── Divider ── */}
      <Centered>
        <RowDivider>
          <DividerDot />
        </RowDivider>
      </Centered>

      {/* ── Row 2: Casual — image left ── */}
      <RowBlock>
        <Centered>
          <RowLabel right>II — Casual</RowLabel>
          <RowTitle right>...Or apply to be my side piece</RowTitle>
        </Centered>

        <Centered>
          <ServePair>
            {/* Image first in DOM, text right */}
            <ImageCell>
              <ServeImage image={CropPapi} />
            </ImageCell>

            <TextBody imageSide="left">
              <BodyText>
                Not ready? No problem. We can keep it casual. I'll make you my
                play thing for a few hours. A hotel room. Dimmed lights. Just
                the two of us — and the accessories and toys handpicked for our
                initiation. My erotically dominant presence charging through
                you. My scent and My voice filling the space around us. And if
                you make Me proud, My voice whispering in your ear "Good
                subbie..."
                <br />
                <br />I get it. Who wouldn't want that? However. My loyal
                submissives are My priority. Yet inevitably, fertile phase hits
                and I feel this huge feminine urge to break in fresh meat, make
                good girls earn their keep and kick consenting balls. So here's
                the deal: My calendar opens occasionally. There is an
                application. Not everyone is approved. Those outside My Inner
                Circle pay the full premium.
                <br />
              </BodyText>
              <ButtonRow>
                <Link to="/sessions">
                  <PrimaryButton>
                    <ButtonLabel>I&apos;ll try my luck, Mistress.</ButtonLabel>
                  </PrimaryButton>
                </Link>
              </ButtonRow>
            </TextBody>
          </ServePair>
        </Centered>
      </RowBlock>
    </SectionOuter>
  );
};

/* ─────────────────────────────────────────────
   Outer section — background + vertical rhythm only,
   no horizontal padding so Centered controls margins.
───────────────────────────────────────────── */

const SectionOuter = styled.section`
  background-color: var(--color-obsidian);
  min-height: 90vh;
  padding-top: 4rem;
  padding-bottom: 10rem;
`;

/* Centred wrapper — mirrors SectionContainer's double padding (Container +
   InternalContainer both use 4.1 rem), giving exactly 8.2 rem per side at
   narrow viewports and auto-centering at wide viewports with max-width 1200 px.
   Because it is perfectly symmetrical, its content midpoint = 50 vw at every
   viewport width, so the grid's 50 / 50 column split places the image boundary
   at the true screen centre while outer edges match all other sections. */
const Centered = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding-left: 8.2rem;
  padding-right: 8.2rem;

  @media screen and (max-width: 468px) {
    padding-left: 5vw;
    padding-right: 5vw;
  }
`;

/* ─────────────────────────────────────────────
   Section-level Paths heading
───────────────────────────────────────────── */

const PathsHeader = styled.div`
  position: relative;
  text-align: center;
  margin-bottom: 5rem;
  overflow: visible;

  @media screen and (max-width: 900px) {
    margin-bottom: 3.5rem;
  }

  @media screen and (max-width: 600px) {
    margin-bottom: 2.5rem;
  }
`;

const PathsScriptina = styled.h1`
  font-family: "Scriptina";
  font-weight: 200;
  font-size: 124px;
  letter-spacing: 10px;
  margin: 0;
  opacity: 0.2;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  text-align: center;
  transform: translateY(-40%);
  pointer-events: none;
  z-index: 0;

  @media screen and (max-width: 900px) {
    font-size: 64px;
    letter-spacing: 6px;
  }

  @media screen and (max-width: 600px) {
    font-size: 64px;
    letter-spacing: 4px;
    transform: translateY(-30%);
  }
`;

const PathsLabel = styled.p`
  font-family: "Ysabeau";
  font-size: 36px;
  letter-spacing: 0.5em;
  text-transform: uppercase;
  color: var(--color-bone);
  margin: 0;
  padding: 1.5rem 0 2rem 0;
  position: relative;
  z-index: 1;

  @media screen and (max-width: 600px) {
    font-size: 24px;
    letter-spacing: 0.4em;
    padding: 1rem 0 1.5rem 0;
  }
`;

/* ─────────────────────────────────────────────
   Per-row header
───────────────────────────────────────────── */

const RowLabel = styled.p`
  font-family: "Ysabeau";
  font-size: 16px;
  letter-spacing: 0.25em;
  text-transform: uppercase;
  color: rgba(239, 233, 225, 0.45);
  margin: 0 0 1rem 0;
  text-align: ${(props) => (props.right ? "right" : "left")};

  @media screen and (max-width: 900px) {
    text-align: left;
  }
`;

const RowTitle = styled.h2`
  font-family: "Ysabeau";
  font-weight: 300;
  text-transform: uppercase;
  font-size: 38px;
  letter-spacing: 0.18em;
  color: var(--color-bone);
  margin: 0 0 1rem 0;
  text-align: ${(props) => (props.right ? "right" : "left")};
  line-height: 1.15;

  &::after {
    content: "";
    display: block;
    width: 3.5rem;
    height: 1.25px;
    background: var(--color-emphasis);
    margin-top: 1.5rem;
    margin-left: ${(props) => (props.right ? "auto" : "0")};

    @media screen and (max-width: 900px) {
      margin-left: 0;
    }
  }

  @media screen and (max-width: 900px) {
    font-size: 1.7rem;
    text-align: left;
    margin-bottom: 1rem;
  }

  @media screen and (max-width: 600px) {
    font-size: 1.4rem;
  }
`;

/* ─────────────────────────────────────────────
   Divider
───────────────────────────────────────────── */

const RowDivider = styled.div`
  display: flex;
  align-items: center;
  margin: 6rem 0;

  &::before,
  &::after {
    content: "";
    flex: 1;
    height: 1px;
    background: rgba(239, 233, 225, 0.15);
  }

  &::before {
    margin-right: 1.25rem;
  }

  &::after {
    margin-left: 1.25rem;
  }

  @media screen and (max-width: 900px) {
    margin: 4rem 0;
  }

  @media screen and (max-width: 600px) {
    margin: 6rem 0;
  }
`;

const DividerDot = styled.span`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--color-emphasis);
  flex-shrink: 0;
`;

/* ─────────────────────────────────────────────
   Grid pair — two equal columns.
   1fr | 1fr means each column = exactly half the Centered content box.
   Because Centered is symmetrical, half its content box = 50 vw,
   so the boundary between image and text lands at the screen centre.
───────────────────────────────────────────── */

const RowBlock = styled.div``;

const ServePair = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  margin-top: 3rem;

  @media screen and (max-width: 900px) {
    grid-template-columns: 1fr;
    margin-top: 2rem;
    row-gap: 2rem;
  }
`;

/* Image cell — fills its 1fr column edge-to-edge.
   mobileFirst: when the image is visually the second DOM child (image-right rows)
   it should still appear above the text on mobile. */
const ImageCell = styled.div`
  min-width: 0;

  @media screen and (max-width: 900px) {
    order: ${(p) => (p.mobileFirst ? -1 : 0)};
  }
`;

/* Text body — sits inside its 1fr column.
   imageSide="right" → margin-right creates the gap between text and the image column.
   imageSide="left"  → margin-left creates the gap between the image column and text. */
const TextBody = styled.div`
  min-width: 0;
  margin-right: ${(p) => (p.imageSide === "right" ? "4rem" : "0")};
  margin-left: ${(p) => (p.imageSide === "left" ? "4rem" : "0")};

  @media screen and (max-width: 900px) {
    margin: 0;
  }
`;

const ServeImage = styled.div`
  background-image: url(${(props) => props.image});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  width: 100%;
  aspect-ratio: 4 / 4;

  @media screen and (max-width: 900px) {
    aspect-ratio: 16 / 9;
  }
`;

/* ─────────────────────────────────────────────
   CTA row
───────────────────────────────────────────── */

const ButtonRow = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: flex-start;
  flex-wrap: wrap;
  margin-top: 2.5rem;

  /* Tablet — single-column stacked layout: centre the buttons */
  @media screen and (min-width: 601px) and (max-width: 900px) {
    justify-content: center;
  }

  @media screen and (max-width: 600px) {
    a {
      flex: 1;
    }

    button {
      width: 100%;
      justify-content: center;
    }
  }
`;

const BodyText = styled.p`
  font-size: 17px;
  line-height: 1.85;
  color: rgba(239, 233, 225, 0.75);
  margin: 0;

  @media screen and (max-width: 600px) {
    font-size: 15px;
  }
`;
